import { Text, View } from '@react-pdf/renderer';
import React, { FC } from 'react';
import { IntlFormatters } from '@formatjs/intl/src/types';

import { filterDeletedValues } from 'lib/utils';
import messages from 'components/ProfileActions/messages';
import { styles } from 'components/ProfileActions/ResumePdf/styles';

type ResumePdfCoursesProps = {
  formatDate: IntlFormatters['formatDate'];
  formatMessage: IntlFormatters['formatMessage'];
  profile: AH$Profile;
};

export const ResumePdfCourses: FC<ResumePdfCoursesProps> = ({
  formatMessage,
  formatDate,
  profile,
}) => {
  const certificates = filterDeletedValues(profile.certificates);

  return certificates.length ? (
    <View style={styles.section}>
      <Text style={[styles.subheading, styles.bold, styles.spaceBottomBig]}>
        {formatMessage(messages.coursesAndCertificates)}
      </Text>
      {certificates.map(({ organization, date, name }) => {
        const currentDate =
          date > 0
            ? formatDate(new Date(date), {
                day: 'numeric',
                month: 'long',
                year: 'numeric',
              })
            : null;
        const currentOrganisation = organization || null;

        return (
          <View style={[styles.section, styles.spaceBottom]}>
            <Text style={[styles.bold, styles.text, styles.spaceBottom]}>{name}</Text>
            {currentDate ? (
              <Text style={[styles.text, styles.spaceBottom]}>{currentDate}</Text>
            ) : null}
            {currentOrganisation ? (
              <Text style={[styles.text, styles.spaceBottom]}>{currentOrganisation}</Text>
            ) : null}
          </View>
        );
      })}
    </View>
  ) : null;
};
